import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CheckoutFormService } from '../../../checkout-form-service/checkout-form.service';
import { View } from '../view.enum';
import { CreditCardProcessingService } from 'src/app/shared/credit-card-processing/credit-card-processing.service';
import { CreditCardProcessingMethod } from 'src/app/shared/credit-card-processing-method.enum';

@Component({
    selector: 'ols-new-card',
    templateUrl: './new-card.component.html',
    styleUrls: ['./new-card.component.scss'],
})
export class NewCardComponent implements OnInit {
    form: FormGroup;
    isStripeEnabled = false;
    @Input() hasCardsOnFile: boolean;
    @Input() surchargeSettings: {
        surchargeEnabled: boolean;
        surchargeRate: number;
    };
    @Output() viewChange: EventEmitter<View> = new EventEmitter();

    get saveCardOnFile(): FormControl {
        return this.form?.get('saveCardOnFile') as FormControl;
    }

    get saveCard(): FormControl {
        return this.form?.get('saveCard') as FormControl;
    }

    constructor(
        private formService: CheckoutFormService,
        private creditCardProcessingService: CreditCardProcessingService
    ) {}

    ngOnInit(): void {
        const processingMethod = this.creditCardProcessingService.getCreditCardProcessingMethod();
        this.isStripeEnabled =
            processingMethod === CreditCardProcessingMethod.Stripe;

        if (!this.isStripeEnabled) {
            this.form = this.formService.createNewCardForm(true);
        } else {
            this.form = this.formService.createStripeForm(true);
        }
    }

    goToSavedCards() {
        this.viewChange.emit(View.CARDS_ON_FILE);
    }
}
